import React from 'react';
import {
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    Banknote,
    Bell,
    BellOff,
    Building2,
    Calculator,
    Calendar,
    CalendarCheck,
    CalendarDays,
    Camera,
    Car,
    ChartColumn,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Circle,
    CircleAlert,
    CircleCheck,
    CirclePlus,
    ClipboardList,
    Clock,
    CloudUpload,
    ConciergeBell,
    Copy,
    CreditCard,
    Droplet,
    Eye,
    EyeOff,
    FileUp,
    FolderOpen,
    GripVertical,
    Gauge,
    Globe,
    House,
    Image,
    Images,
    Inbox,
    Info,
    Landmark,
    LoaderCircle,
    LogOut,
    Menu,
    Minus,
    Package,
    PackageOpen,
    Pencil,
    Phone,
    Play,
    Plus,
    Receipt,
    RefreshCw,
    Ruler,
    Save,
    Search,
    Send,
    Settings,
    Square,
    Trash2,
    TriangleAlert,
    Trophy,
    User,
    UserCog,
    Users,
    X,
} from 'lucide-react';
import './Icon.css';

const ICONS = {
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    area: Square,
    back: ArrowLeft,
    bank: Landmark,
    bell: Bell,
    'bell-slash': BellOff,
    box: Package,
    'box-open': PackageOpen,
    building: Building2,
    calculator: Calculator,
    calendar: Calendar,
    'calendar-alt': Calendar,
    'calendar-day': CalendarDays,
    camera: Camera,
    car: Car,
    cash: Banknote,
    'chart-bar': ChartColumn,
    check: Check,
    'check-circle': CircleCheck,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    circle: Circle,
    clients: Users,
    clipboard: ClipboardList,
    'clipboard-list': ClipboardList,
    clock: Clock,
    'cloud-upload-alt': CloudUpload,
    'concierge-bell': ConciergeBell,
    copy: Copy,
    'credit-card': CreditCard,
    droplet: Droplet,
    edit: Pencil,
    eye: Eye,
    'eye-slash': EyeOff,
    'exchange-alt': ArrowLeftRight,
    'exclamation-circle': CircleAlert,
    'file-upload': FileUp,
    'folder-open': FolderOpen,
    globe: Globe,
    grip: GripVertical,
    home: House,
    image: Image,
    images: Images,
    inbox: Inbox,
    'info-circle': Info,
    menu: Menu,
    minus: Minus,
    orders: ClipboardList,
    'paper-plane': Send,
    phone: Phone,
    play: Play,
    plus: Plus,
    'plus-circle': CirclePlus,
    receipt: Receipt,
    ruler: Ruler,
    save: Save,
    search: Search,
    settings: Settings,
    'sign-out-alt': LogOut,
    spinner: LoaderCircle,
    'sync-alt': RefreshCw,
    'tachometer-alt': Gauge,
    times: X,
    today: CalendarCheck,
    trash: Trash2,
    trophy: Trophy,
    user: User,
    'user-cog': UserCog,
    users: Users,
    warning: TriangleAlert,
};

/**
 * Единый набор значков приложения. Размер по умолчанию равен размеру текста, цвет наследуется.
 * Значок рядом с текстом скрыт от экранных читалок; значок без текста получает label.
 */
const Icon = ({ name, size = '1em', label, spin = false, className = '' }) => {
    const Glyph = ICONS[name];
    if (!Glyph) return null;
    const classes = ['app-icon', spin ? 'app-icon-spin' : '', className].filter(Boolean).join(' ');
    const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true };
    return <Glyph size={size} color="currentColor" className={classes} {...a11y} />;
};

export default Icon;
